// ============================================
// TotalCount.js
// トップページの全件数をfetchで取得して表示
// ============================================

function loadTotalCount() {
  const el = document.querySelector('[data-total-url]');
  if (!el) return;

  fetch(el.dataset.totalUrl)
    .then((res) => (res.ok ? res.json() : Promise.reject()))
    .then((data) => {
      if (typeof data.total === 'number') {
        const target = el.querySelector('.js-total');
        if (target) target.textContent = data.total.toLocaleString('ja-JP');
      }
    })
    .catch(() => {});
}

export { loadTotalCount };
